import Brands from '@/views/brand/Brands.vue'
import brandModalRouter from '@/router/routers/brandModal'

const brandRouter = (beforeEnter) => {
    return {
        beforeEnter: beforeEnter,
        name: 'Marcas',
        path: '/marcas',
        meta: {
            requiresAuth: true,
            breadcrumb: true,
            breadcrumbName: 'Marcas',
            layout: 'default'
        },
        component: Brands,
        children: [
            brandModalRouter(beforeEnter, 'CadastrarMarca', 'marcas', false),
            brandModalRouter(beforeEnter, 'DetalheMarca', 'marcas', true)
        ]
    }
}

export default brandRouter
